/**
 * Features API — the authenticated feature-flag list (cloud-migration wave 13).
 * GET /features returns exactly the four named flags for the signed-in user.
 */
import { apiClient } from './client';

export interface FeatureFlags {
  graph_view: boolean;
  suggestions: boolean;
  morning_briefs: boolean;
  voice_capture: boolean;
  ingest_document: boolean;
  ingest_image: boolean;
  voice_knowledge: boolean;
}

export type FeatureName = keyof FeatureFlags;

/** All-disabled flags — the fail-closed default (Req 7.7). */
export const ALL_DISABLED: FeatureFlags = {
  graph_view: false,
  suggestions: false,
  morning_briefs: false,
  voice_capture: false,
  ingest_document: false,
  ingest_image: false,
  voice_knowledge: false,
};

export async function getFeatures(): Promise<FeatureFlags> {
  const res = await apiClient.get<{ features: Partial<FeatureFlags> }>('/features');
  // Normalize: coerce known flags to boolean, default false.
  return {
    graph_view: Boolean(res?.features?.graph_view),
    suggestions: Boolean(res?.features?.suggestions),
    morning_briefs: Boolean(res?.features?.morning_briefs),
    voice_capture: Boolean(res?.features?.voice_capture),
    ingest_document: Boolean(res?.features?.ingest_document),
    ingest_image: Boolean(res?.features?.ingest_image),
    voice_knowledge: Boolean(res?.features?.voice_knowledge),
  };
}
